// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sort-wrapper[data-v-ecfa08b2],.sort-wrapper .sort-title[data-v-ecfa08b2]{align-items:center;display:flex}.sort-wrapper .sort-title .icon[data-v-ecfa08b2]{color:var(--primary-400);height:.26rem;margin-right:.05rem;width:.26rem}.sort-wrapper .sort-title .text[data-v-ecfa08b2]{color:#000;font-size:.14rem;font-weight:500;margin-right:.04rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
